<template>
  <div class="fragment">
    <BalanceHistoryHead
        @toggleFilter="toggleFilter"
        @filter="$emit('filter')"
        @changeFilter="changeFilter"
        :showFilter="showFilter"
        :countFilterParams="countFilterParams"
    />

    <div class="table-filter-wrap">

      <BalanceHistoryFilter
          :showFilter="showFilter"
          @close="closeFilter"
          @changeFilter="changeFilter"
          @resetFilter="$emit('resetFilter')"
          :filterGetParams="filterGetParams"
          :PAYMENT_HISTORY_TYPE="PAYMENT_HISTORY_TYPE"
      />

      <BalanceHistoryTable
          @showMore="$emit('showMore')"
          @resetFilter="$emit('resetFilter')"
          @downloadFiles="type => $emit('downloadFiles', type)"
          :countFilterParams="countFilterParams"
          :PAYMENT_HISTORY_TYPE="PAYMENT_HISTORY_TYPE"
      />
    </div>
  </div>
</template>

<script>
  import BalanceHistoryHead from "./BalanceHistoryHead/BalanceHistoryHead";
  import BalanceHistoryFilter from "./BalanceHistoryFilter/BalanceHistoryFilter";
  import BalanceHistoryTable from "./BalanceHistoryTable/BalanceHistoryTable";

  export default {
    name: "BalanceHistoryTableUser",
    components: {
      BalanceHistoryHead,
      BalanceHistoryFilter,
      BalanceHistoryTable,
    },

    props: [
      'countFilterParams',
      'filterGetParams',
      'PAYMENT_HISTORY_TYPE',
    ],

    data(){
      return{
        showFilter: false,
        filterId: '',
        filterName: '',
        forPage: 10,
        page: 1,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },

      changeShopType(index) {
        this.$emit('changeShopType', index)
      },


      changeFilter(data) {
        this.$emit('changeFilter', data)
      },
    }
  }
</script>

<style scoped>

</style>
